import React, {useEffect, useState} from 'react';
import {Button, Card, Loader} from 'semantic-ui-react';
import Header from '../internalCommons/header';
import {createOrderScreens} from '../../constants/internalScreens';
import OrdersTable from './ordersTable';
import './../styles/styles.scss';
import DragAndDropFile from './DragAndDropFile';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import {isOk} from '../utils';
import OrdersTableResponse from './ordersTableResponse';

const CreateOrder = (props) => {
  const [originsCount] = useState(0);

  const cleanOrdersTable = () => {
    props.cleanCreateOrder();
  };

  const validateProcessedData = (ordersProcessedData) => {
    let hasErrors = false;
    for (let i = 0; i < ordersProcessedData.length; i++) {
      if (!isOk(ordersProcessedData[i].errorExternalColor) ||
      !isOk(ordersProcessedData[i].errorModelInOrigin) ||
      !isOk(ordersProcessedData[i].errorInternalColor) ||
      !isOk(ordersProcessedData[i].errorModel) ||
      !isOk(ordersProcessedData[i].errorTotal) ||
      !isOk(ordersProcessedData[i].errorEquivalence) ||
      !isOk(ordersProcessedData[i].errorRepeatedOriginalOrderNumber) ||
      !isOk(ordersProcessedData[i].errorModelActive) ||
      !isOk(ordersProcessedData[i].errorOrderNumberExists)) {
        hasErrors = true;
        break;
      }
    }
    if (hasErrors) {
      props.setValidOrderFalse();
    } else {
      props.setValidOrderTrue();
    }
  };

  useEffect(() => {
    props.ordersProcessedData && validateProcessedData(props.ordersProcessedData);
  }, [props.ordersProcessedData]);
  
  return (
    <>
      <Header screen={createOrderScreens.create} title={'Crear Orden'} loading={props.loading} />
      {props.loading ?
        <Loader active className='top-full-spaced'/> :
        <Card raised fluid className='card-center-custom-create'>
          <Button
            secondary
            onClick={() => cleanOrdersTable()}
            className='custom-button-table'
          >
            Limpiar
          </Button>
          {
            props.ordersProcessedData ?
              props.createdOrder ?
                <OrdersTableResponse
                  dataTable={props.createdOrder}
                  countRows={originsCount}
                /> :
                <OrdersTable
                  dataTable={props.ordersProcessedData}
                  countRows={originsCount}
                /> :
              <DragAndDropFile />
          }
        </Card>
      
      }
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    'loading': state.manageOrders.loading,
    'ordersRawData': state.manageOrders.ordersRawData,
    'ordersProcessedData': state.manageOrders.ordersProcessedData,
    'createdOrder': state.manageOrders.createdOrder,
  };
};

const {uploadOrderFile,
  cleanCreateOrder,
  setValidOrderFalse,
  setOrderProcessedData,
  setOrderPrice,
  setValidOrderTrue,
} = Actions;

export default connect(mapStateToProps, {
  uploadOrderFile,
  cleanCreateOrder,
  setValidOrderFalse,
  setOrderProcessedData,
  setOrderPrice,
  setValidOrderTrue,
})(CreateOrder);
